import React, { useState, useEffect } from 'react';

const PasswordGate = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // Check if password protection is enabled for this environment
  const isProtected = process.env.REACT_APP_PASSWORD_PROTECTED === 'true';
  const requiredPassword = process.env.REACT_APP_ACCESS_PASSWORD;

  useEffect(() => {
    if (!isProtected) {
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }

    // Check if already authenticated in this session
    const sessionAuth = sessionStorage.getItem('env_authenticated');
    if (sessionAuth === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, [isProtected]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (password === requiredPassword) {
      setIsAuthenticated(true);
      sessionStorage.setItem('env_authenticated', 'true');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  // If loading, show nothing or a loader
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  // If authenticated or not protected, show the app
  if (isAuthenticated) {
    return <>{children}</>;
  }

  // Show password gate
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <div className="mb-6 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            FixDirectly
          </h1>
          <p className="text-sm text-gray-600">
            {process.env.REACT_APP_ENVIRONMENT === 'staging' ? 'Staging' : 'Development'} Environment
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Enter Access Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
              placeholder="Password"
              autoFocus
            />
          </div>

          {error && (
            <div className="p-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-md">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Access Environment
          </button>
        </form>

        <p className="mt-6 text-xs text-center text-gray-500">
          This environment is password protected. Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
};

export default PasswordGate;
